import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginService } from '@app/login.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [
    NgOptimizedImage,
    RouterModule,
    CommonModule,
    AngularSvgIconModule,
    RouterModule
  ],
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignupComponent {

  public desktop = new BehaviorSubject(true);

  private destroyed = new Subject<void>();

  constructor(private responsive: BreakpointObserver, private loginService: LoginService) {}

  ngOnInit() {
    this.responsive.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
    ])
    .pipe(
      takeUntil(this.destroyed)
    )
    .subscribe(result => {
      if (result.matches) {
        this.desktop.next(false);
      } else {
        this.desktop.next(true);
      }
    });
  }

  login() {
    this.loginService.showLogin();
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
